"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _Badge = require("./Badge.types");
var _VARIANT_STYLE_STRATE, _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var getBadgeSize = function getBadgeSize(size) {
  return size === _Badge.Size.MEDIUM ? '8px' : '4px';
};
var defaultStyleGenerator = function defaultStyleGenerator(kind) {
  var _applicableStyles;
  var defaultStyles = "\n    background-color: ".concat(_js["default"].alias.color.surface.notification["default"], ";\n    color: ").concat(_js["default"].alias.color.text.inverse["default"], ";\n    border: 1px solid ").concat(_js["default"].alias.color.border.inverse["default"], ";\n  ");
  var applicableStyles = (_applicableStyles = {}, _defineProperty(_applicableStyles, _Badge.Kind.DEFAULT, defaultStyles), _defineProperty(_applicableStyles, _Badge.Kind.INVERSE, "\n      ".concat(defaultStyles, "\n      color: ").concat(_js["default"].alias.color.text.inverse["default"], ";\n    ")), _applicableStyles);
  return "\n    ".concat(applicableStyles[kind], "\n  ");
};
var subtleStyleGenerator = function subtleStyleGenerator(kind) {
  var _applicableStyles2;
  var subtleStyles = "\n    background-color: ".concat(_js["default"].alias.color.surface.highlight["default"], ";\n    color: ").concat(_js["default"].alias.color.text["default"], ";\n    border: 1px solid ").concat(_js["default"].alias.color.border["default"], ";\n  ");
  var applicableStyles = (_applicableStyles2 = {}, _defineProperty(_applicableStyles2, _Badge.Kind.DEFAULT, subtleStyles), _defineProperty(_applicableStyles2, _Badge.Kind.INVERSE, "\n      ".concat(subtleStyles, "\n      background-color: ").concat(_js["default"].alias.color.surface.transparent.lighter, ";\n      border-color: ").concat(_js["default"].alias.color.border.inverse.lighter, ";\n      color: ").concat(_js["default"].alias.color.text.inverse["default"], ";\n    ")), _applicableStyles2);
  return "\n    ".concat(applicableStyles[kind], "\n  ");
};
var VARIANT_STYLE_STRATEGIES = (_VARIANT_STYLE_STRATE = {}, _defineProperty(_VARIANT_STYLE_STRATE, _Badge.Variant.DEFAULT, defaultStyleGenerator), _defineProperty(_VARIANT_STYLE_STRATE, _Badge.Variant.SUBTLE, subtleStyleGenerator), _VARIANT_STYLE_STRATE);
var Badge = exports.Badge = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var $content = _ref.$content,
    $size = _ref.$size,
    $variant = _ref.$variant,
    $kind = _ref.$kind;
  return "\n    width: ".concat(getBadgeSize($size), ";\n    height: ").concat(getBadgeSize($size), ";\n    border-radius: ").concat(_js["default"].badge.shape.border.radius, ";\n\n    font-size: ").concat(_js["default"].alias.typography.caption.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.caption.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.caption.lineHeight, ";\n\n    align-items: center;\n    display: flex;\n    justify-content: center;\n\n    ").concat(VARIANT_STYLE_STRATEGIES[$variant]($kind), "\n\n    ").concat($content !== 'undefined' ? "\n      width: calc(".concat($content.length + 1, " * 8px);\n      height: 16px;\n      border-radius: ").concat(_js["default"].badge.shape.border.radius, ";\n\n      &::before {\n        content: \"").concat($content, "\";\n      }\n    ") : '', "\n  ");
});